import type { Card } from '../shared/types';

/** The age belongs to the card, including when it is kept as a past event. */
export function renderCardAgeLabel(stage: Card['stage'], kind?: 'life'|'setback'): string {
  if(stage==='all' && !kind)return '';
  const age=stage.replace('-','–');
  const zh=stage==='all'?'':stage==='51+'?'51 岁以上':`${age} 岁`;
  const en=stage==='all'?'':`Ages ${age}`;
  const typeZh=kind==='life'?'人生底牌':kind==='setback'?'挫折牌':'';
  const typeEn=kind==='life'?'Life Card':kind==='setback'?'Setback':'';
  return `<span class="card-age-label">${[zh,typeZh].filter(Boolean).join(' · ')}<span lang="en">${[en,typeEn].filter(Boolean).join(' · ')}</span></span>`;
}
